import { toSuccess } from 'react-async-client';
import { assoc, compose } from 'ramda';

import {
    SET_NOTIFICATION_PERMISSION,
    SET_NOTIFICATION_SUBSCRIBED,
    PUT_NOTIFICATION_OPTIONS,
    GET_NOTIFICATION_OPTIONS,
    POST_SUBSCRIBE_NOTIFICATION,
    POST_UNSUBSCRIBE_NOTIFICATION,
    ALLOW_NOTIFICATION_PERMISSION,
    GET_COMPANY_INFO,
} from 'constants/actionTypes.js';

const initialState = {
    notificationDisabled: false,
    notificationActivated: false,
    notificationPermission: null,
    notificationSubscribed: false,
    notificationPermissionRequest: false,
    subscriptions: {
        eventNotificationPeriod: 60,
        notifyProjectsEnabled: true,
        notifyPersonEnabled: true,
        notifyNotDoneEnabled: true,
        notifyEventEnabled: true,
        notifyChangeRequestStatusEnabled: true,
    }
};

export const notificationReducer = (state = initialState, action) => {
    switch (action.type) {
        case toSuccess(GET_COMPANY_INFO):
            return compose(
                assoc('notificationEnabled', Boolean(!action.payload.sso)),
            )(state);
        case ALLOW_NOTIFICATION_PERMISSION:
        case SET_NOTIFICATION_PERMISSION:
            return compose(
                assoc('notificationPermission', action.payload),
                assoc('notificationPermissionRequest', false),
            )(state);
        case SET_NOTIFICATION_SUBSCRIBED:
            return assoc('notificationSubscribed', action.payload, state);
        case toSuccess(POST_SUBSCRIBE_NOTIFICATION):
            return compose(
                assoc('notificationSubscribed', true),
                assoc('notificationActivated', false),
            )(state);
        case toSuccess(POST_UNSUBSCRIBE_NOTIFICATION):
            return compose(
                assoc('notificationSubscribed', false),
                assoc('notificationActivated', true),
            )(state);
        case toSuccess(GET_NOTIFICATION_OPTIONS):
            return assoc('subscriptions', action.payload, state);
        case toSuccess(PUT_NOTIFICATION_OPTIONS):
            return assoc('subscriptions', action.requestAction.payload, state);
        default:
            return state;
    }
};
